import { PropsWithChildren } from 'react';
import { Box } from 'reflexbox';

import { SubSectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';

export default function Property(props: PropsWithChildren<{ title: string }>) {
	return (
		<>
			<Box mb={1}>
				<SubSectionTitle isLight>{props.title}</SubSectionTitle>
			</Box>
			{props.children}
			<Box my={3} />
		</>
	);
}
